/**
 * "Evento" é só um marcador genérico gravado pela jornada, não um tipo escolhido pelo cliente
 * (Aniversário, Chá de Panela, Batizado…). Vazio e "Evento" contam como tipo NÃO informado.
 */
export const isRealEventType = (value: string | null | undefined): boolean => {
  const v = String(value ?? '').trim().toLowerCase();
  return v !== '' && v !== 'evento';
};

/** Tipos de evento oferecidos em infos-festa; qualquer outro texto veio da descrição do tipo "Outros". */
export const STANDARD_EVENT_TYPES = ['Aniversário', 'Confraternização', 'Chá de Panela', 'Chá de Cozinha', 'Batizado', 'Coffee Break', 'Outros'];

/** Descrição digitada pelo cliente: sem espaços repetidos, primeira letra maiúscula (TUDO MAIÚSCULO vira minúsculo). */
export const formatCustomEventType = (raw: string | null | undefined): string => {
  let text = String(raw ?? '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  const letters = text.replace(/[^A-Za-zÀ-ÿ]/g, '');
  if (letters.length > 1 && letters === letters.toUpperCase()) text = text.toLocaleLowerCase('pt-BR');
  return text.charAt(0).toLocaleUpperCase('pt-BR') + text.slice(1);
};

/** Valor a gravar em events.event_type: com "Outros", vale o que o cliente descreveu. */
export const resolveEventTypeForSave = (tipo: string, outros: string): string =>
  tipo === 'Outros' && outros.trim() ? formatCustomEventType(outros) : tipo;

/** Valor salvo -> estado do formulário: um tipo fora da lista volta como "Outros" + descrição. */
export const splitStoredEventType = (stored: string): { tipo: string; outros: string } =>
  STANDARD_EVENT_TYPES.includes(stored) ? { tipo: stored, outros: '' } : { tipo: 'Outros', outros: stored };


/** Tipos oferecidos na criação manual de evento pelo fornecedor. "Outro" abre um campo para descrever o evento. */
export const MANUAL_EVENT_TYPES = [
  'Aniversário Infantil',
  'Aniversário Adulto',
  'Casamento',
  'Chá de Bebê',
  'Batizado',
  'Confraternização',
  'Corporativo',
  'Social',
  'Outro',
];
export const OTHER_EVENT_TYPE = 'Outro';

/** Valor a gravar: com "Outro", vale o que o fornecedor descreveu (sem descrição, continua "Outro"). */
export const resolveManualEventType = (tipo: string, outro: string): string =>
  tipo === OTHER_EVENT_TYPE && outro.trim() ? formatCustomEventType(outro) : tipo;

/** Valor salvo -> formulário: um tipo fora da lista volta como "Outro" + descrição. */
export const splitManualEventType = (stored: string | null | undefined): { tipo: string; outro: string } => {
  const value = String(stored ?? '').trim();
  if (!value) return { tipo: '', outro: '' };
  return MANUAL_EVENT_TYPES.includes(value) ? { tipo: value, outro: '' } : { tipo: OTHER_EVENT_TYPE, outro: value };
};
